var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.9093 13.2429C58.0882 6.42185 48.8368 2.5898 39.1903 2.5898C29.5438 2.5898 20.2924 6.42185 13.4713 13.2429C6.65023 20.064 2.81818 29.3154 2.81818 38.9619C2.81818 48.6084 6.65023 57.8598 13.4713 64.6809C20.2924 71.502 29.5438 75.334 39.1903 75.334C48.8368 75.334 58.0882 71.502 64.9093 64.6809C71.7304 57.8598 75.5624 48.6084 75.5624 38.9619C75.5624 29.3154 71.7304 20.064 64.9093 13.2429ZM39.1903 70.459C21.8231 70.459 7.69323 56.3294 7.69323 38.9619C7.69323 21.5944 21.8228 7.46485 39.1903 7.46485C56.5578 7.46485 70.6874 21.5944 70.6874 38.9619C70.6874 56.3294 56.5578 70.459 39.1903 70.459Z",
    fill: "#0A6D9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7088 46.5879L22.5248 35.4041L19.0777 38.8511L33.7088 53.4822L59.2264 27.9648L55.7791 24.5177L33.7088 46.5879Z",
    fill: "#0A6D9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSvgrepocom);
export default __webpack_public_path__ + "static/media/check-circle_svgrepo.com.8e1defff01a62547b89d29e9aadf6753.svg";
export { ForwardRef as ReactComponent };